/* eslint-disable no-lonely-if */
/* eslint-disable no-else-return */
import { getPartnerAccessToken } from '@leagueplatform/sso-util';
import { format } from 'date-fns';
import {
  PHONE_NUMBER_TYPE,
  FORM_API_TYPE,
  STATE_VALUE,
} from '../../types/online-forms.types';

export const memberNameOption = (profileResponseData: any) => {
  const dependents = profileResponseData?.demographics?.dependents;
  const demographicsData = profileResponseData?.demographics;

  const dependentsUser = dependents?.map((option: any) => ({
    value: `${option.firstName} ${option.lastName}`,
    label: `${option.firstName} ${option.lastName}`,
  }));

  const mainUser = {
    value: `${demographicsData?.firstName} ${demographicsData?.lastName}`,
    label: `${demographicsData?.firstName} ${demographicsData?.lastName}`,
  };
  dependentsUser?.unshift(mainUser);
  return dependentsUser;
};

function modifyNumber(value: string) {
  if (!value) return value;
  const phoneNumberLength = value.length;
  let phNum: any = '';
  if (phoneNumberLength === 10) {
    phNum = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
  }
  return phNum;
}

export const phoneNumberOption = (profileResponseData: any) => {
  const contactPoints = profileResponseData?.demographics?.contactPoints;
  let selectedNumber = [];
  if (contactPoints) {
    const filteredArray = contactPoints?.filter(
      (option: any) => option.type === PHONE_NUMBER_TYPE.PHONE,
    );

    selectedNumber = filteredArray?.map((option: any) => ({
      value: modifyNumber(option.value),
      label: `${option.use} ${':'}  ${modifyNumber(option.value)}`,
      use: option.use,
    }));

    const otherPhoneNumber = {
      value: PHONE_NUMBER_TYPE.OTHERS,
      label: PHONE_NUMBER_TYPE.OTHERS,
      use: PHONE_NUMBER_TYPE.OTHERS,
    };
    selectedNumber?.push(otherPhoneNumber);
  } else {
    const otherPhoneNumber = {
      value: PHONE_NUMBER_TYPE.OTHERS,
      label: PHONE_NUMBER_TYPE.OTHERS,
      use: PHONE_NUMBER_TYPE.OTHERS,
    };
    selectedNumber?.push(otherPhoneNumber);
  }
  return selectedNumber;
};

export function formatPhoneNumber(value: string) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6,
  )}-${phoneNumber.slice(6, 10)}`;
}

export function stateOption() {
  const state = STATE_VALUE?.map((option: any) => ({
    value: option,
    label: option,
  }));
  return state;
}

export function isEmpty(value: string) {
  return value === null || value === undefined || value?.length === 0;
}

export function isNotEmpty(value: string) {
  if (!value) return false;
  return value.length > 0;
}

export function isValidatePhoneLength(val: string) {
  return val?.length >= 1 && val?.length < 14;
}

export function isValidZipCodeLength(val: string) {
  return val?.length >= 1 && val?.length <= 4;
}

export function isLeapYear(year: string) {
  return new Date(Number(year), 1, 29).getDate() === 29;
}

export function isDateCalendarValid(inpStrArr: any, inpNumArr: any) {
  if (inpNumArr[0] > 12) {
    return false;
  } else if (inpStrArr[0] === '02') {
    if (isLeapYear(inpStrArr[2])) {
      if (inpNumArr[1] > 29) {
        return false;
      } else {
        return true;
      }
    } else {
      if (inpNumArr[1] > 28) {
        return false;
      } else {
        return true;
      }
    }
  } else if (
    inpStrArr[0] === '01' ||
    inpStrArr[0] === '03' ||
    inpStrArr[0] === '05' ||
    inpStrArr[0] === '07' ||
    inpStrArr[0] === '08' ||
    inpStrArr[0] === '10' ||
    inpStrArr[0] === '12'
  ) {
    if (inpNumArr[1] > 31) {
      return false;
    } else {
      return true;
    }
  } else {
    if (inpNumArr[1] > 30) {
      return false;
    } else {
      return true;
    }
  }
}

export function isValidDate(inp: string) {
  const today = format(new Date(), 'MM/dd/yyyy');
  const dateStrArr = today.split('/');
  const dateNumArr = dateStrArr.map((date: any) => Number(date));
  const inpStrArr = inp.split('/');
  const inpNumArr = inpStrArr.map((date: any) => Number(date));
  if (/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/\d{4}$/.test(inp)) {
    if (inpNumArr[2] < 1890) {
      return false;
    } else if (inpNumArr[0] > 12) {
      return false;
    } else if (dateNumArr[2] < inpNumArr[2]) {
      return false;
    } else if (dateNumArr[2] > inpNumArr[2]) {
      return isDateCalendarValid(inpStrArr, inpNumArr);
    } else {
      if (isDateCalendarValid(inpStrArr, inpNumArr)) {
        if (dateNumArr[0] < inpNumArr[0]) {
          return false;
        } else if (dateNumArr[0] > inpNumArr[0]) {
          return true;
        } else {
          if (dateNumArr[1] < inpNumArr[1]) {
            return false;
          } else {
            return true;
          }
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
}

export function isAlphanumeric(str: string) {
  return /^[a-zA-Z0-9]+$/.test(str);
}

// export async function getAccessToken(
//   url: string,
//   ubk: string,
//   apiType?: string,
// ) {
//   let formType = '';
//   if (apiType === 'forms') {
//     const urlArr = url.split('=');
//     const [, urlP2] = urlArr;
//     formType = urlP2;
//   }
//   let token = '';
//   token = await getPartnerAccessToken('highmark');
//   // console.log(token,"token");
//   const requestOptions = {
//     method: 'GET',

//     headers: new Headers({
//       Accept: 'application/json',
//       Authorization: `Bearer ${token}`,
//       ...(ubk && { brandUbk: ubk }),
//     }),
//   };
//   console.log(requestOptions,"requestOptions")
//   try {
//     return await fetch(url, requestOptions)
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error(
//             `This is an HTTP error: The status is ${response.status}`,
//           );
//         }
//         return response.json();
//       })
//       .then((data) => {
//         const resultData = {
//           ...data,
//           type: formType,
//         };
//         return resultData;
//       });
//   } catch (error) {
//     const errObj = {
//       errMsg: error,
//     };
//     return errObj;
//   }
// }

export async function getAccessToken(
  url: string,
  ubk: string,
  apiType?: string,
  accessToken?: string,
) {
  let formType = '';
  if (apiType === 'forms') {
    const urlArr = url.split('=');
    const [, urlP2] = urlArr;
    formType = urlP2;
  }

  const token = !['', null, undefined].includes(accessToken)
    ? accessToken
    : await getPartnerAccessToken('highmark');

  const requestOptions = {
    method: 'GET',

    headers: new Headers({
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
      ...(ubk && { brandUbk: ubk }),
    }),
  };

  try {
    return await fetch(url, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`,
          );
        }
        return response.json();
      })
      .then((data) => {
        const resultData = {
          ...data,
          type: formType,
        };
        return resultData;
      });
  } catch (error) {
    const errObj = {
      errMsg: error,
    };
    return errObj;
  }
}

export function phoneRegex(val: string) {
  return val.replace(/[^0-9]/g, '').substring(0, 10);
}

export function isAlphaNumbericWithSpace(val: string) {
  return val.replace(/[^a-zA-Z0-9 ]+/gi, '');
}

export function onlyAlphabets(val: string) {
  return val.replace(/[^a-zA-Z ]+/gi, '');
}

export function isNoSpace(val: string) {
  return /^\s/.test(val);
}

export function isDecimal(val: string) {
  const valArr = val.replace(/[^0-9.]+/gi, '').split('.');
  if (valArr.length === 1) {
    return valArr[0];
  } else if (valArr.length === 2) {
    if (valArr[0] !== '') {
      return `${valArr[0]}.${valArr[1]}`;
    } else {
      return '';
    }
  } else {
    if (valArr[0] !== '') {
      const valArrSpl = valArr.splice(0, 1);
      return `${valArrSpl[0]}.${valArr.join('')}`;
    } else {
      return '';
    }
  }
}

export function submitForm(formName: string) {
  const userData = JSON.parse(sessionStorage.getItem('formData') || '{}');
  let userData1 = {};
  switch (formName) {
    case FORM_API_TYPE.MEDICATION_EXCEPTION:
      userData1 = {
        memberName: userData?.memberName,
        memberId: userData?.memberId,
        memberDob: userData?.dateOfBirth,
        memberPhoneNo:
          userData?.phoneNumber === PHONE_NUMBER_TYPE.OTHERS
            ? phoneRegex(userData?.otherPhoneNumber)
            : phoneRegex(userData?.phoneNumber),
        prescriberName: userData?.fullName,
        prescriberFaxNo: userData?.faxNumber,
        prescriberPhoneNo: phoneRegex(userData?.prescriberPhoneNumber),
        addr1: userData?.addressLine1,
        city: userData?.city,
        state: userData?.state,
        zipCode: userData?.zipCode,
        medicationName: userData?.medicationName,
        reasonForMedication: userData?.reasonForMedication,
      };
      break;
    case FORM_API_TYPE.STEP_THERAPY:
      userData1 = {
        memberName: userData?.memberName,
        memberId: userData?.memberId,
        memberDob: userData?.dateOfBirth,
        memberPhoneNo:
          userData?.phoneNumber === PHONE_NUMBER_TYPE.OTHERS
            ? phoneRegex(userData?.otherPhoneNumber)
            : phoneRegex(userData?.phoneNumber),
        prescriberName: userData?.prescriberName,
        prescriberPhoneNo: phoneRegex(userData?.prescriberPhoneNumber),
        drugName: userData?.drugName,
        strength: userData?.strength,
        quantity: userData?.quantity,
        reasonForRequest: userData?.explainYourRequest,
      };
      break;
    case FORM_API_TYPE.DENTAL_CLAIM:
      userData1 = {
        payload: {
          formType: 'dental',
          dentalInfo: {
            dentalPlanName: userData?.dentalPlanName,
            dentalPlanAddress: `${userData?.dentalPlanAddress1}, ${userData.dentalPlanAddress2}, ${userData?.dentalPlanCity}, ${userData?.dentalPlanState} ${userData?.dentalPlanZipCode}`,
            transactionTypes: [
              `Statement of services: ${userData?.statementOfServices}`,
              `Request for Predetermination: ${userData?.requestForPredetermination}`,
              `Early and Periodic screening: ${userData?.earlyAndPeriodicScreening}`,
            ],
            memberName: userData?.memberName,
            address: `${userData?.addressLine1}, ${userData.addressLine2}, ${userData?.city}, ${userData?.state} ${userData?.zipCode}`,
            policyHolderDob: userData?.dateOfBirth,
            gender: userData?.gender,
            memberId: userData?.memberId,
            isPolicyHolderPatient: userData?.isPolicyHolderPatient === 'YES',
            dependentDetails: [
              {
                patientRelationship: userData?.patientRelationship,
                patientName: userData?.patientName,
                patientDob: userData?.patientDateOfBirth,
                address: `${userData?.patientAddressLine1}, ${userData.patientAddressLine2}, ${userData?.patientCity}, ${userData?.patientState} ${userData?.patientZipCode}`,
                gender: userData?.patientGender,
              },
            ],
            otherCoverage: {
              hasDentalCoverage: userData?.hasDentalCoverage,
              hasMedicalCoverage: userData?.hasMedicalCoverage,
              notApplicable: userData?.notApplicable,
            },
            policyHolderDetails: [
              {
                primaryInsurance: userData?.primaryInsurance === 'Yes',
                insuranceDetails: [
                  {
                    policyHolderName: userData?.policyHolderName,
                    policyHolderDob: userData?.policyHolderDob,
                    policyHolderGender: userData?.policyHolderGender,
                    policyID: userData?.policyID,
                    planNumber: userData?.planNumber,
                    relationshipToPolicyHolder:
                      userData?.relationshipToPolicyHolder,
                    otherInsuranceCompany: userData?.otherInsuranceCompany,
                    otherInsuranceAddress: `${userData?.otherInsuranceAddressLine1}, ${userData.otherInsuranceAddressLine2}, ${userData?.otherInsuranceAddressCity}, ${userData?.otherInsuranceAddressState} ${userData?.otherInsuranceAddressZipCode}`,
                    explanationOfBenefits: userData?.eobAttachments?.map(
                      (eob: any, index: any) => {
                        const eobObj = {
                          attachmentId: index,
                          attachmentPath: eob.attachmentPath,
                          fileName: eob.newName,
                          isLoading: false,
                        };
                        return eobObj;
                      },
                    ),
                  },
                ],
              },
            ],
            itemizedBill: userData?.itemizedAttachments.map(
              (item: any, index: any) => {
                const itemObj = {
                  attachmentId: index,
                  attachmentPath: item.attachmentPath,
                  fileName: item.newName,
                  isLoading: false,
                };
                return itemObj;
              },
            ),
            patientConsent: userData?.patientConsent === true,
            paymentAuthorization: userData?.paymentAuthorization === true,
            entityName: userData?.entityName,
          },
        },
      };
      break;
    case FORM_API_TYPE.DIRECT_REIMBURSEMENT_CLAIM:
      userData1 = {
        payload: {
          formType: 'vision',
          visionInfo: {
            address: `${userData?.addressLine1}, ${userData.addressLine2}, ${userData?.city}, ${userData?.state} ${userData?.zipCode}`,
            businessPhone: userData?.businessPhoneNumber,
            dependentDetails: [
              {
                patientDob: userData?.patientDateOfBirth,
                patientName: userData?.patientName,
                patientRelationship: userData?.patientRelationship,
              },
            ],
            disInfoForm: {
              disAddress: `${userData?.dispenserAddressLine1}, ${userData.dispenserAddressLine2}, ${userData?.dispenserCity}, ${userData?.dispenserState} ${userData?.dispenserZipCode}`,
              disLicenseNumber: userData?.dispenserSLN,
              disMemberName: userData?.dispenserName,
              disPhoneNumber: userData?.dispenserPhoneNumber,
              isDispenserSameInfo: userData.isDispenserSame === 'YES',
            },
            examinerInfoForm: {
              exAddress: `${userData?.examinerAddressLine1}, ${userData.examinerAddressLine2}, ${userData?.examinerCity}, ${userData?.examinerState} ${userData?.examinerZipCode}`,
              exLicenseNumber: userData?.examinerSLN,
              exMemberName: userData?.examinerName,
              exPhoneNumber: userData?.examinerPhoneNumber,
            },
            homePhone: userData?.homePhoneNumber,
            isPolicyHolderPatient: userData?.isPolicyHolderPatient === 'YES',
            memberId: userData?.memberId,
            memberName: userData?.memberName,
            services: userData?.services?.map((ser: any) => ({
              dateOfService: ser.dateOfService,
              expenseIncurred: ser.expenseIncurred,
              explanationOfBenefits: ser.attachments?.map(
                (eob: any, index: any) => {
                  const eobObj = {
                    attachmentId: index,
                    attachmentPath: eob.attachmentPath,
                    fileName: eob.newName,
                    isLoading: false,
                  };
                  return eobObj;
                },
              ),
              serviceType: {
                label: ser.serviceType,
              },
            })),
            totalExpenses: userData?.totalExpenses,
            visionAcknowledgement: userData?.fraudAcknowledgemnt === true,
          },
        },
      };
      break;
    default:
  }
  return userData1;
}

export function emptyStorage() {
  sessionStorage.removeItem('formData');
  sessionStorage.removeItem('otherCoverage');
}

export function updateFormData(value: any) {
  const prevData = JSON.parse(sessionStorage.getItem('formData') || '{}');
  Object.keys(value).forEach((val) => {
    prevData[val] = value[val];
  });
  sessionStorage.setItem('formData', JSON.stringify(prevData));
}

export function dataURItoBlob(dataURI: string) {
  const byteString = atob(dataURI);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const int8Array = new Uint8Array(arrayBuffer);
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < byteString.length; i++) {
    int8Array[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([int8Array], { type: 'application/pdf' });
  return blob;
}

export function openPrefilledPdf(content: string) {
  const blob = dataURItoBlob(content);
  const link = URL.createObjectURL(blob);
  window.open(link, '_blank');
}

export function formatDate(date: string) {
  const dateArr = date.split('-');
  return `${dateArr[1]}/${dateArr[2]}/${dateArr[0]}`;
}
